import { media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledAddressDiv = styled.div`
    margin-bottom: 24px;
 `;

export const StyledSectionTitle = styled.span`
 font-weight: bold;
`;
export const StyledAddress = styled.div`
margin-bottom: 16px;
${media.sm`
    display: table-cell;
    padding-right: 120px;
    Section{
        margin-top:0px;
    }
`}
`;
